"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserType = exports.USER_TYPES = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useGlobalState_1 = require("./useGlobalState");
var USER_TYPES;
(function (USER_TYPES) {
    USER_TYPES["VIP"] = "vip";
    USER_TYPES["DEFAULT"] = "default";
})(USER_TYPES = exports.USER_TYPES || (exports.USER_TYPES = {}));
var useUserType = function () {
    var _a = (0, useGlobalState_1.useGlobalState)(keys_1.globalStateKeys.USER_TYPE, USER_TYPES.DEFAULT), state = _a.state, changeState = _a.changeState;
    return (0, react_1.useMemo)(function () { return ({
        userType: state,
        changeUserType: changeState,
    }); }, [state, changeState]);
};
exports.useUserType = useUserType;
